import React from "react";
import {
  Link as RouterLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

export const routing = {
  // EN-only SEO mode for now. Re-enable de/fr/it when translated content is live.
  locales: ["en"],
  defaultLocale: "en",
};

function getLocaleFromPathname(pathname) {
  const firstSegment = pathname.split("/").filter(Boolean)[0];
  if (firstSegment && routing.locales.includes(firstSegment)) {
    return firstSegment;
  }
  return routing.defaultLocale;
}

function localizePath(pathname, locale) {
  const cleanPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const segments = cleanPath.split("/").filter(Boolean);
  if (segments.length === 0) return `/${locale}`;
  if (routing.locales.includes(segments[0])) {
    segments[0] = locale;
    return `/${segments.join("/")}`;
  }
  return `/${locale}${cleanPath === "/" ? "" : cleanPath}`;
}

export function Link({ href, ...props }) {
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);
  return React.createElement(RouterLink, {
    to: localizePath(href, locale),
    ...props,
  });
}

export function redirect(href) {
  window.location.assign(href);
}

export function usePathname() {
  const location = useLocation();
  return location.pathname;
}

export function useRouter() {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    replace: (to, options) => {
      const currentLocale = getLocaleFromPathname(location.pathname);
      const nextLocale = options?.locale ?? currentLocale;

      if (typeof to === "string") {
        navigate(localizePath(to, nextLocale), { replace: true });
        return;
      }

      const basePath = to.pathname ?? location.pathname;
      navigate(localizePath(basePath, nextLocale), { replace: true });
    },
  };
}

export function getPathname(path, options) {
  const locale = options?.locale ?? routing.defaultLocale;
  return localizePath(path, locale);
}

export function useLocaleParams() {
  return useParams();
}
